import type { ReduxState } from './druid/types/internal/ReduxState';

export default ({ dictateState }: ReduxState) => dictateState;
